import { UpdateUserConsentsMutation } from '../queries/updateUserConsents.generated';
import { graphql } from 'msw';

export const userUpdateConsentHandler =
    graphql.mutation<UpdateUserConsentsMutation>(
        'updateUserConsents',
        (_, res, ctx) => {
            return res(
                ctx.data({
                    updateUserConsents: true
                })
            );
        }
    );
